import NavigationSidebar                              from "components/Navigation/NavigationSidebar"
import ProductCard                                    from "components/Product/ProductCard"
import categoryStore                                  from "stores/categoryStore"
import Slider                                         from "components/Slider/Slider"
import { Col, Row }                                   from "elemental-react16"
import { observer }                                   from "mobx-react"
import PropTypes                                      from "prop-types"
import React, { Component }                           from "react"
import Responsive                                     from "react-responsive"
import { Link }                                       from "react-router-dom"
import { Breadcrumb, Button, Container, Grid, Image } from "semantic-ui-react"
import settingStore                                   from "stores/settingStore"
import LinkCms                                        from "./components/Link/LinkCms"
import ProductList                                    from "./components/Product/ProductList"
import ProductSearchBasic                             from "./components/Product/ProductSearchBasic"
import CategoryShortcuts                              from "plugin/CategoryShortcuts/CategoryShortcuts"
import shop                                           from "shop/shop"
import { WordPressFAQ }                               from "WordPressFAQ"
import DynamicContent                                 from "./DynamicContent";

const ConditionalContainer = ( { children, container, className = "" } ) => {
  if ( container ) return <Container className={className}>{children}</Container>
  return <div className={className}>{children}</div>
}

const WPCategory = observer( ( { row } ) => {
  const categories = categoryStore.categories
  const category = shop.categoriesById.get( row.category ) || { children: categories }
  console.log( { category, categories } )
  return (<div className="WPCategory">
    {shop.categories && <CategoryShortcuts title={row.title} category={category}/>}</div>)
} )

@observer
class WordPress extends Component {
 state = {
    progressiveProductLists: {}
  }

  progressiveIntervals = {}

  componentDidMount() {
    this.initProgressiveProducts()
  }

  componentDidUpdate(prevProps) {
    if (prevProps.page !== this.props.page) {
      this.clearAllIntervals()
      this.initProgressiveProducts()
    }
  }

  componentWillUnmount() {
    console.log( "Clearing intervals" )
    this.clearAllIntervals()


  }

  clearAllIntervals = () => {
    Object.values(this.progressiveIntervals).forEach(clearInterval)
    this.progressiveIntervals = {}
  }

  startProgressiveLoading = (layoutKey, ids) => {
    if (!ids || !ids.length) return

    const fullIds = ids.map(o => o.id)
    let size = 20

    this.setState(prev => ({
      progressiveProductLists: {
        ...prev.progressiveProductLists,
        [layoutKey]: fullIds.slice(0, size)
      }
    }))

    const interval = setInterval(() => {
      size *= 2

      if (size >= fullIds.length) {
        this.setState(prev => ({
          progressiveProductLists: {
            ...prev.progressiveProductLists,
            [layoutKey]: fullIds
          }
        }))
        clearInterval(interval)
      } else {
        this.setState(prev => ({
          progressiveProductLists: {
            ...prev.progressiveProductLists,
            [layoutKey]: fullIds.slice(0, size)
          }
        }))
      }
    }, 120)

    this.progressiveIntervals[layoutKey] = interval
  }

  initProgressiveProducts = () => {
    const { page } = this.props
    if (!page || !page.acf || !page.acf.layout) return

    page.acf.layout.forEach((row, layoutKey) => {
      if (row.acf_fc_layout === "products" && row.ids && row.ids.length) {
        this.startProgressiveLoading(layoutKey, row.ids)
      }
    })
  }


  
  render() {
    const categories = shop.categories
    const { additionalContent = null, insertAfter = {} } = this.props
    const mode = settingStore.get( "orderMode" )
    let { page } = this.props
    if ( page && page.acf && page.acf.faq ) return <WordPressFAQ faq={page.acf.faq}/>
    if ( !page || !page.content && !page.acf ) return null
    if ( page && !page.acf.layout && page.content && page.content.rendered ) return <TextPost
      className={this.props.className}
      html={page.content.rendered}/>
    if ( !page || !page.acf.layout || page.acf.layout.length < 1 ) return null
    let images = []
    const { acf } = page
    let { layout } = acf
    if ( acf.use_preorder_layout && mode === "MODE_PREORDER" ) {
      layout = acf.layout_preorder.layout
    }
    let sidebarPlaced = false
    let sidebarCapacity = false
    let beforeSidebar = []
    let onSidebar = []
    let afterSidebar = []
    layout.forEach( ( row, layoutKey ) => {
      let wrapInRow = false
      let output = false
      const useSidebar = sidebarCapacity >= 1
      let title = false
      
      switch (row.acf_fc_layout) {
        case "sidebar":
          sidebarPlaced = true
          sidebarCapacity = 1 + Number( row.size ) || 1
          break;
        case "slider":
          output = <ConditionalContainer className={`Slider relative ${row.className}`}
                                         container={row.useContainer && !useSidebar}>
            <Slider
              centerMode
              autoPlay={true}
              interval={5200}
              transitionTime={0}
              centerSlidePercentage={100}
              infiniteLoop={true}
              showThumbs={false}
              showArrows={false}
              showIndicators={false}
              showStatus={false}>
              {row.content.map( slide => {
                if ( slide.cta ) {
                  return <Link
                    to={slide.cta.url}
                    target={slide.cta.target}
                    key={slide.img}
                    className="Slide">
                    <div className="slider-content ui container">
                      <div className="html" dangerouslySetInnerHTML={{ __html: slide.content }}/>
                      {(slide.cta && slide.cta.title) &&
                        <Button inverted primary as={Link} to={slide.cta.url}
                                target={slide.cta.target}>{slide.cta.title}</Button>}
                    </div>
                    
                    <Image src={slide.img}/>
                  </Link>
                } else {
                  return <div
                    key={slide.img}
                    className="Slide">
                    <div className="slider-content ui container">
                      <div className="html" dangerouslySetInnerHTML={{ __html: slide.content }}/>
                      {slide.cta &&
                        <Button inverted primary as={Link} to={slide.cta.url}
                                target={slide.cta.target}>{slide.cta.title}</Button>}
                    </div>
                    
                    <Image src={slide.img}/>
                  </div>
                }
              } )}
            </Slider>
          </ConditionalContainer>
          break;
        
        case "categories":
          var visibility = row.visibilityMode
          console.log( 'Sichtbarkeit: ' + visibility )
          
          if ( visibility !== undefined ) {
            if ( visibility === 'modeAll' || (visibility === 'modePreorder' && mode === 'MODE_PREORDER') || (visibility === 'modeAvailable' && mode === 'MODE_AVAILABLE') ) {
              output = <div className={"ui container"}>
                <WPCategory row={row} categories={categories}/>
              </div>
            }
          } else {
            output = <div className={"ui container"}>
              <WPCategory row={row} categories={categories}/>
            </div>
          }
          break;
        
        case "images":
          wrapInRow = false
          output =
            <ConditionalContainer className={row.className} container={row.useContainer && !useSidebar}>
              <Grid stackable doubling columns={"equal"}>
                <Grid.Row>
                  {row.img && row.img.map( ( { img, url, cta }, key ) => {
                    if ( cta ) {
                      url = url || cta.url
                    }
                    return (
                      <Grid.Column key={key}
                                   className="cms-content cms--images relative ">
                        <div className={"cms-content-item cms-image"}>
                          <div className="img-container">
                            {cta && <div className="">
                              <Button inverted primary size="large" className="img-button absolute left-2 bottom-2 margin-0"
                                      as={Link}
                                      to={cta.url}
                                      target={cta.target}>{cta.title}</Button>
                            </div>}
                            <LinkCms to={url}>
                              <img src={img.url}
                                   className="img-responsive "
                                   alt=""/>
                            </LinkCms>
                          </div>
                        </div>
                      </Grid.Column>
                    )
                  } )}
                </Grid.Row>
              </Grid>
            </ConditionalContainer>
          break
        case "products": {
          const progressiveList =
            this.state.progressiveProductLists[layoutKey] ||
            row.ids && row.ids.slice(0, 40).map(o => o.id)
          let wrongList = false
          const size = "1/" + (progressiveList && progressiveList.length || row.ids.length)
          if (progressiveList && row.ids ) {
            if(row.ids[0].id.toString() !== progressiveList[0].toString()) {
            (async () => {
              wrongList = true
              this.clearAllIntervals()
              return
            })()
            }
          }
          output = (
            <ConditionalContainer
              className={row.className}
              container={row.useContainer && !useSidebar}
            >
              <ProductList
                key={layoutKey}
                displayMode={row.displayMode}
                title={row.title}
                sm={size}
                list={wrongList ? [] : progressiveList}
                repeat={ProductCard}
              />
            </ConditionalContainer>
          )

          break
        }
        case "search":
          output = createSearchComponent( { row, useSidebar } )
          break
        case "html":
          // PARSE META
          row.metaValue = false
          try {
            row.metaValue = JSON.parse( row.meta )
          }
          catch (err) {
            row.metaValue = false
          }
          
          var sizeHtml = "1/" + row.html.length
          if ( row.html.length === 1 ) {
            sizeHtml = "1"
          }
          wrapInRow = false
          title = row.title
          if ( row.metaValue && row.metaValue.module ) {
            output = <DynamicContent config={row.metaValue}/>
            break;
          }
          if ( !row.html.length ) return null
          output =
            <ConditionalContainer className={`cms-html cms-item-${layoutKey} ${row.className ? row.className : ""}`} container={row.useContainer && !useSidebar}>
              <Grid columns={row.html.length}>
                <Grid.Row>
                  {row.html.map( ( block, key ) => {
                    const { html, grid = {} } = block
                    if ( grid.width === "0" ) grid.width = null
                    if ( grid.desktop === "0" ) grid.desktop = null
                    if ( grid.tablet === "0" ) grid.tablet = null
                    if ( grid.mobile === "0" ) grid.mobile = null
                    return (
                      <Grid.Column
                        style={{
                          backgroundColor: block.bgColor || null
                        }}
                        width={grid.width}
                        computer={grid.desktop}
                        tablet={grid.tablet}
                        mobile={grid.mobile}
                        key={key}
                        className={`pb3 ${block.className}`}
                      >
                        <div className={`${row.css ? row.css : ""} ${block.className} block-wrapper relative`}>
                          <div key={key}
                               className={`cms-content cms--html  relative z-2 `}
                               dangerouslySetInnerHTML={{ __html: html }}>
                          </div>
                          {key === 1 && additionalContent}
                        </div>
                        {block.img && <div className="absolute bottom-0 left-0  right-0 z-1">
                          <img src={block.img} alt="Bild"/>
                        </div>}
                      </Grid.Column>
                    )
                  } )}
                </Grid.Row>
              </Grid>
              <DynamicContent config={row.metaValue}/>
            
            </ConditionalContainer>
          break
      }
      
      let rowTitle = null
      if ( title ) {
        rowTitle = (
          <div className="row-title">{title}</div>
        )
      }
      
      const section = <section key={layoutKey}
                               className={`cms-content cms-item-${layoutKey}`}>
        <div className={`cms-inner-wrapper ${acf.className}`}>
          {rowTitle}
          {output}
        </div>
      </section>
      
      const injected = insertAfter[layoutKey]
        ? <div key={`insert-${layoutKey}`} className={`cms-injected cms-injected-${layoutKey}`}>{insertAfter[layoutKey]}</div>
        : null

      if ( sidebarCapacity === false ) { beforeSidebar.push( section ); if ( injected ) beforeSidebar.push( injected ) }
      if ( sidebarCapacity === 0 ) { afterSidebar.push( section ); if ( injected ) afterSidebar.push( injected ) }
      if ( sidebarCapacity > 0 ) {
        onSidebar.push( section )
        if ( injected ) onSidebar.push( injected )
        sidebarCapacity--
      }
    } )
    return <div className={`cms-entry page-slug-${page.slug} page--${page.slug}`}>
      {page.acf.style && <style dangerouslySetInnerHTML={{ __html: page.acf.style }}/>}
      {beforeSidebar}
      {sidebarPlaced &&
        <Container>
          <Grid divided="vertically">
            <Responsive minWidth={790}>
              <Grid.Row>
                <Grid.Column width={3}>
                  {/*BREADCRUMBS*/}
                  {/*<div className="db pv3">*/}
                  {/*  <Breadcrumb>*/}
                  {/*    <Breadcrumb.Section link as={Link} to="/">Home</Breadcrumb.Section>*/}
                  {/*  </Breadcrumb>*/}
                  {/*</div>*/}
                  <div className="">
                    <NavigationSidebar/>
                  </div>
                </Grid.Column>
                
                <Grid.Column width={13}>
                  {/*<CategoriesGrid/>*/}
                  {onSidebar}
                </Grid.Column>
              
              </Grid.Row>
            
            </Responsive>
            
            <Responsive maxWidth={790}>
              <Grid.Row>
                <Grid.Column width={16}>
                  {onSidebar}
                </Grid.Column>
              </Grid.Row>
            </Responsive>
          </Grid>
        </Container>
      }
      <div className="after-sidebar">
        {afterSidebar}
      </div>
    </div>
  }
}


const TextPost = ( { html, className = "" } ) => {
  return <div className={`TextPost ${className}`}>
    <div className="post"
         dangerouslySetInnerHTML={{ __html: html }}/>
  </div>
}


const createSearchComponent = ( props ) => {
  const { row, useSidebar } = props
  row.cats = row.cats || []
  const cats = row.cats.map( cat => cat.id )
  const { count = 4, dir = "desc", sort = "des" } = row.meta || {}
  let filters = false
  if ( row.advanced ) {
    try {
      filters = JSON.parse( row.filters )
    }
    catch (err) {
      filters = false
      console.warn( "Invalid Filter", { row } )
    }
  }
  
  return <ConditionalContainer className={row.className} container={row.useContainer && !useSidebar}>
    <Col key={`k${row.query}+${row.cats[ 0 ]}`}>
      <ProductSearchBasic title={row.title}
                          cats={cats[ 0 ]}
                          count={count}
                          dir={dir}
                          sort={sort}
                          filters={filters}
                          query={row.query}
                          displayMode={row.displayMode}
                          repeat={ProductCard}/>
    </Col>
  </ConditionalContainer>
}


WordPress.propTypes = {
  page: PropTypes.object
}

export default WordPress



// WEBPACK FOOTER //
// ./src/WordPress.js